module.exports = __webpack_public_path__ + "img/p5.5e4e5c03.png";